import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from '../resources/logo.png'
import './nav.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faInstagram, faLinkedin, faGithub, faYoutube} from "@fortawesome/free-brands-svg-icons";
import { useEffect, useRef, useState } from 'react';

function MyNav() {
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const [navOpen, setNavOpen] = useState(false);

    const [y, setY] = useState(0);

    const handleNavigation = (e) => {

        const window = e.currentTarget;
    
        if (y > window.scrollY || y < window.scrollY) {
    
          if (window.innerWidth <= 991 && document.getElementById("responsive-navbar-nav").classList.contains("show")) {
    
            document.getElementById("responsive-navbar-nav").classList.remove("show");
            document.getElementById("toggle_btn").classList.remove("open");
            setNavOpen(navOpen => !navOpen);
          
          }
    
          else if (window.innerWidth > 991 && document.getElementById("responsive-navbar-nav").classList.contains("show")) {
    
            document.getElementById("responsive-navbar-nav").classList.remove("show");
    
          }
    
    
        }
    
        setY(window.y);
    
      };


      useEffect(() => {

        setY(window.scrollY);
        window.addEventListener("scroll", (e) => handleNavigation(e));
    
        if (windowSize.current[0] <= 991) {
    
          document.getElementById("responsive-navbar-nav").classList.add("collapsing");
          document.getElementById("responsive-navbar-nav").classList.remove("collapse");
    
        }
    
      }, []);

    const toggleNav = () => {

        if (windowSize.current[0] <= 991) {
    
          document.getElementById("responsive-navbar-nav").classList.add("collapsing");
    
          if (!navOpen) {
    
            document.getElementById("toggle_btn").classList.add("open")
            document.getElementById("responsive-navbar-nav").classList.add("show");
    
          }
          
          else {
    
            document.getElementById("toggle_btn").classList.remove("open")
            document.getElementById("responsive-navbar-nav").classList.remove("show");
    
          }
    
          setNavOpen(navOpen => !navOpen);
    
        }
    
      }

    return (
        <Navbar collapseOnSelect expand="lg" variant="light" className="navTop myNavbar fixed-top" id="navbarItem">
            <Container>
                <Navbar.Brand href="/siya-portfolio/" className={"myLogo"}>
                    <img src={Logo} width={75}/>
                    <a href={"/siya-portfolio/"} className={"myName"}>Siya Choudhary</a>
                </Navbar.Brand>
                {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" className='toggleBtn'/> */}
                <button className = "navbar-toggler second-button toggleBtn" type = "button" data-toggle = "collapse" data-target = "#responsive-navbar-nav"
              aria-controls = "responsive-navbar-nav" aria-expanded = "false" aria-label = "Toggle navigation" onClick = {toggleNav}>
              <div className = "animated-icon2" id = {"toggle_btn"}><span></span><span></span><span></span><span></span></div>
            </button>
                <Navbar.Collapse id="responsive-navbar-nav" className='navbar-collapse'>
                    <Nav className="me-auto">
                        {/*<Nav.Link href="#features">Siya Choudhary</Nav.Link>*/}
                    </Nav>
                    <Nav>
                        <CustomLink href={"/siya-portfolio/"}>HOME</CustomLink>
                        <CustomLink href={"/siya-portfolio/aboutMe"}>ABOUT</CustomLink>
                        <NavDropdown title="MY PORTFOLIOS" id="collasible-nav-dropdown" className={"linkItem"}>
                            <NavDropdown.Item href="/siya-portfolio/techPortfolio">PROGRAMMING</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/siya-portfolio/artPortfolio">ART</NavDropdown.Item>
                        </NavDropdown>
                        {/* <CustomLink href={"/siya-portfolio/blog"}>BLOG</CustomLink> */}
                        <CustomLink href={"/siya-portfolio/contact"}>CONTACT</CustomLink>
                        <div className=''>
                            <ul>
                                {/* <li><a href={"https://www.instagram.com/siyac_art/"} target={"_blank"}><FontAwesomeIcon icon={faInstagram} /></a></li> */}
                                <li><a href={"https://www.linkedin.com/in/siya-choudhary-2b0b89229/"} target={"_blank"}><FontAwesomeIcon icon={faLinkedin} /></a></li>
                                <li><a href={"https://github.com/siyachoudhary"} target={"_blank"}><FontAwesomeIcon icon={faGithub} /></a></li>
                                {/* <li><a href={"https://www.youtube.com/channel/UCWRd7PQTU_SsYW-VJ09i2Jw"} target={"_blank"}><FontAwesomeIcon icon={faYoutube} /></a></li> */}
                            </ul>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

function CustomLink({href, children, ...props}){
    const path = window.location.pathname
    return (
        path===href?
        <Nav.Link href={href} {...props} className={"active"}>{children}</Nav.Link>:
            <Nav.Link href={href} {...props}>{children}</Nav.Link>
    )

}

export default MyNav;